// Source unique des types de dépense, catégories de salaire et modes de paiement.
// Les libellés servent aussi de clés i18n (vue-i18n retombe sur la clé si absente).

export const EXPENSE_TYPES = [
  { value: "Event", label: "Evenement", color: "indigo", icon: "mdi-calendar-star" },
  { value: "Current", label: "Courante", color: "blue-grey", icon: "mdi-cash" },
  { value: "Salary", label: "Salaire", color: "green", icon: "mdi-account-cash" },
  { value: "Works", label: "Travaux", color: "orange", icon: "mdi-hammer-wrench" },
  { value: "Bill", label: "Facture", color: "deep-purple", icon: "mdi-file-document-outline" },
  { value: "Import", label: "Import", color: "teal", icon: "mdi-import" },
  { value: "Monthly", label: "Charge mensuelle", color: "brown", icon: "mdi-calendar-refresh" }
]

export const SALARY_CATEGORIES = [
  { value: "employee", label: "Employé" },
  { value: "provider", label: "Prestataire" }
]

export const PAYMENT_METHODS = [
  { value: "cheque", label: "Chèque", icon: "mdi-checkbook" },
  { value: "cash", label: "Espèce", icon: "mdi-cash" }
]

const TYPE_MAP = EXPENSE_TYPES.reduce((acc, t) => ((acc[t.value] = t), acc), {})
const SALARY_MAP = SALARY_CATEGORIES.reduce((acc, c) => ((acc[c.value] = c), acc), {})

/**
 * Métadonnées d'affichage d'un type de dépense.
 * @param {string} type - code du type (ex. "Salary")
 * @param {string|null} salaryCategory - "employee" | "provider" (si type = Salary)
 * @returns {{label: string, color: string, icon: string}}
 */
export function expenseTypeMeta(type, salaryCategory) {
  const meta = TYPE_MAP[type] || {
    label: type || "—",
    color: "grey",
    icon: "mdi-help-circle-outline"
  }
  if (type === "Salary" && salaryCategory && SALARY_MAP[salaryCategory]) {
    return {
      label: `${meta.label} — ${SALARY_MAP[salaryCategory].label}`,
      color: meta.color,
      icon: meta.icon
    }
  }
  return { label: meta.label, color: meta.color, icon: meta.icon }
}

const PAYMENT_MAP = PAYMENT_METHODS.reduce((acc, p) => ((acc[p.value] = p), acc), {})

/**
 * Métadonnées d'affichage d'un mode de paiement.
 * @param {string} method - "cheque" | "cash"
 * @returns {{label: string, icon: string}|null}
 */
export function paymentMethodMeta(method) {
  return PAYMENT_MAP[method] || null
}
